import type { GetUsersQuery } from "@src/__generated__/graphql";
import type { GetUserForEditQuery } from "@src/__generated__/urql-graphql";
import type { UserType } from "@src/stores/models/Me";
import { userScopeToType } from "@src/utils/userScopeToType";

type TUser =
  | NonNullable<GetUsersQuery["users"]>["data"][0]
  | NonNullable<GetUserForEditQuery["user"]>;

export class UserModel {
  id: TUser["id"];
  type: UserType;
  full_name: TUser["full_name"];
  first_name: TUser["first_name"];
  last_name: TUser["last_name"];
  codename: TUser["codename"];
  archived_at: TUser["archived_at"];
  image: TUser["image"];
  email: TUser["email"];
  phone: TUser["phone"];
  note: TUser["note"];
  team: TUser["team"];
  roles: TUser["roles"];
  brands: TUser["brands"];
  profile?: Omit<NonNullable<TUser["profile"]>, "internal_hourly_rate">;
  PMActiveProjectsCount: TUser["PMActiveProjectsCount"];
  enabled_two_factor_authentication: TUser["enabled_two_factor_authentication"];
  permissions: TUser["permissions"];

  constructor(src: TUser) {
    this.id = src.id;
    this.first_name = src.first_name;
    this.last_name = src.last_name;
    this.archived_at = src.archived_at;
    this.codename = src.codename;
    this.full_name = src.full_name;
    this.image = src.image;
    this.email = src.email;
    this.phone = src.phone;
    this.note = src.note;
    this.team = src.team;
    this.roles = src.roles;
    this.brands = src.brands;
    this.profile = src.profile ?? undefined;
    this.type = userScopeToType(src.scope?.value);
    this.PMActiveProjectsCount = src.PMActiveProjectsCount;
    this.enabled_two_factor_authentication =
      src.enabled_two_factor_authentication;
    this.permissions = src.permissions;
  }

  get hasActiveAssets(): boolean {
    return this.PMActiveProjectsCount > 0;
  }

  get canHaveAssets(): boolean {
    return this.permissions.user_haveProjectsAssigned;
  }

  static fromGetUsersQuery(src: GetUsersQuery["users"]) {
    return src?.data.map((i) => new UserModel(i)) ?? [];
  }
}
